// @flow
import { Check } from '@phosphor-icons/react'
import * as React from 'react'
import ButtonClear from 'ui/ButtonClear'

import cn from '@/utils/tailwind/cn'

type Props = {
  isVisible: boolean,
  onClose?: () => void | Promise<void>,
  canDismiss?: boolean,
  title?: string,
  description?: React.Node,
  hideButton?: boolean,
  buttonTitle?: string,
  hasCallback?: boolean,
  callbackDelay?: number,
  callback?: () => void,
  fixed?: boolean,
  className?: string,
}

function ModalSuccessOld({
  isVisible,
  onClose,
  title,
  description,
  hideButton,
  buttonTitle,
  hasCallback,
  callbackDelay,
  callback,
  fixed,
  className,
}: Props): React.Node {
  React.useEffect(() => {
    let timeout = null
    if (isVisible && hasCallback && callback) {
      timeout = setTimeout(() => {
        callback()
      }, callbackDelay ?? 5000)
    }
    return () => {
      if (timeout !== null) {
        clearTimeout(timeout)
        timeout = null
      }
    }
  }, [callback, callbackDelay, hasCallback, isVisible])

  let modalClass = fixed === false ? '' : ' fixed'

  return (
    isVisible && (
      <div
        className={cn(
          'clearfix bottom-0 left-0 right-0 top-0 z-[101] m-0 flex items-center justify-center bg-screen',
          modalClass,
          className
        )}
      >
        <div className="relative flex max-w-md flex-1 items-center overflow-hidden rounded-lg bg-white shadow-lg">
          <i className="absolute left-0 top-0 h-2 w-full bg-[linear-gradient(118deg,#5dbb61,#a3d5a6)]" />
          <div className="flex flex-1 flex-col items-center gap-2 p-8 pt-12">
            <i className="mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-green-100/80">
              <Check className="text-4xl text-[#51a855]" weight="bold" />
            </i>
            {title && (
              <h4 className="text-center text-3xl font-bold text-gray-900">
                {title}
              </h4>
            )}
            {description && (
              <p className="text-center text-lg text-gray-500">{description}</p>
            )}
            <div className="flex justify-center">
              {!hideButton && (
                <ButtonClear dataCy="dismiss-button" onClick={onClose}>
                  {buttonTitle || 'Dismiss'}
                </ButtonClear>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  )
}

export default ModalSuccessOld
